import { useBack } from "../http";
import { LoginDTO } from "../types/LoginDTO";

export class LoginService {
	constructor() {}
	axiosInstance = useBack();

	async autentica(login: LoginDTO, id: string | undefined) {
		const url = `/form/${id}/login`;
		try {
			const response = await this.axiosInstance.post<LoginDTO>(url, login);
			return { ...response };
		} catch (error) {
			console.log(`Erro ao realizar o login: `, error);
			return undefined;
		}
	}
}